import $ from 'jquery';
import wheel from 'wheel';
import normalizeWheel from 'normalize-wheel';
import 'flickity-imagesloaded';

import Odometer from 'odometer';

class BjzmTimeline {
	constructor() {
		if( $(".timeline-slider").length < 1 ) {
			return;
		}
		
		this.target = $('.timeline-slider');
		this.screenWidth = $(window).outerWidth() - $(".header--main").outerWidth();

		setTimeout( () => {
			this.initSlider();
		}, 1000);

	}

	on_images_load(){
		let imgLoading = true;
		let images = $('img').length;

		while(imgLoading){
			let loading = $('img').filter(img => img.complete !== true);
		    if (loading.length == images) {
		      imgLoading = false;
		    }
		}
	}
	
	/**
	 * Add a class to each child of an active flickity slide
	 */
	animateSlideItems() {
		let self = this;

		$(".timeline__year").find(".timeline__item:not(.timeline__item--is-active)").each(function(index, item){
			let $item = $(this);
			let winRight = $(window).scrollLeft() + $(window).outerWidth();

			let itemFromLeft = $item.offset().left;
			if( itemFromLeft < winRight ) {
				$item.addClass('timeline__item--is-active');
				if ($item.hasClass('timeline__decade')) {
					let title = $item.find('.timeline__decade-title');
					let startyear = parseInt(title.data('from'));
					let endyear = parseInt(title.data('to'));
					console.log('starting flip...',title.text(),startyear,endyear);


					let od = new Odometer({
					  el: title[0],
					  value: startyear,

					  // Any option (other than auto and selector) can be passed in here
					  format: '',
					  theme: 'default'
					});

					od.update(endyear)
				}
			}
		});
	}

	initSlider() {

		let self = this;

		let $timeline = $('.timeline-slider');

		$timeline.flickity({
			imagesLoaded: true,
			cellAlign: 'left',
			contain: true,
			freeScroll: true,
			prevNextButtons: false,
			pageDots: false
		});

		$timeline.on( 'dragStart.flickity', function( event, pointer ) {
			document.ontouchmove = function (e) {
				e.preventDefault();
			}
		});

		// events to trigger animations
		$timeline.on( 'dragMove.flickity', function( event, pointer ) {
			document.ontouchmove = function (e) {
				e.preventDefault();
			}
		});


		// events to trigger animations
		$timeline.on( 'scroll.flickity', function( event, progress ) {
			self.animateSlideItems();
			document.ontouchmove = function (e) {
				e.preventDefault();
			}
		});


		$timeline.on( 'dragEnd.flickity', function( event, pointer ) {
			document.ontouchmove = function (e) {
				return true;
			}
		});


		this.slideWidth();

		$timeline.on('change.flickity', function( event, index ) {
			$(`.timeline-footer__year`).removeClass('timeline-footer__year--active');
			$(`.timeline-footer__year--count-${index}`).addClass('timeline-footer__year--active');
		});

		$(".timeline-footer__year-link").on('click', function(e){
			e.preventDefault();
			var index = $(this).data('decade-index');
			$timeline.flickity('select', index);
		});

		this.setScroll($timeline);
		this.iosFix($timeline);
		this.setHeight();

		$('.timeline-wrapper').removeClass('timeline-loading');
	}

	slideWidth(){
		let slides = this.target.find('.timeline__item');
		let sortedSlides = [];
		let len = slides.length;
		let count = 0;
		let ratios = this.imageWidths();
		for(let i = 0 ; i < len ; i++){

			if( !$(slides[i]).hasClass('timeline__decade') && $(window).innerWidth() > 920){
				$(slides[i]).css({'width': 332 * ratios[count]});
				count++;
			}else if ( !$(slides[i]).hasClass('timeline__decade') ){
				$(slides[i]).css({'width': 220 * ratios[count]});
				count++;				
			}
		}
	}

	imageWidths(){
		let images = this.target.find('.timeline__item-image img');
		let ratios = [];
		let len = images.length;

		for(let i = 0 ; i < len ; i++){
			ratios[i] =  images[i].naturalWidth / images[i].naturalHeight;
		}

		return ratios;
	}

	setHeight(){
		let height = $(window).height() - $('.header:visible').outerHeight() - 50;
		// console.log(height,height+'px !important');
		// $('.timeline-wrapper').css('height','508px !important');
		$('.timeline-wrapper')[0].style.setProperty('height', height+'px', 'important');
	}

	iosFix($target){
		$target.on( 'dragStart.flickity', function( event, pointer ) {
	    document.ontouchmove = function (e) {
	        	e.preventDefault();
		    }
		});
		$target.on( 'dragEnd.flickity', function( event, pointer ) {
		    document.ontouchmove = function (e) {
		        return true;
		    }
		});
	}

	setScroll($target){
		wheel.addWheelListener($target.data()['flickity'].$element[0], event => {
		    const wheelNormalized = normalizeWheel(event);
		    $target.data()['flickity'].applyForce(-wheelNormalized.pixelY / 4);
		    $target.data()['flickity'].startAnimation();
		    $target.data()['flickity'].dragEnd();
		});
	}

	// timelineScroll(event){
	//     const wheelNormalized = normalizeWheel(event);
	//     slider.applyForce(-wheelNormalized.pixelY / 4);
	//     slider.startAnimation();
	//     slider.dragEnd();
	// }
}

module.exports = BjzmTimeline;